/* eslint-disable complexity */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TRF from './Trf/Trf';
import QRF from './Qrf/Qrf';
import FRF from './Frf/Frf';
import Remediation from './Remediation/Remediation';

class TrfReview extends Component {

  noDataAvailable = () => (
    <div className="ncss-row">
      <div className="ncss-col-sm-12 u-bold">No data to show</div>
    </div>
  );

  render() {
    const {
      trfData: { trfDetails, qrfDetails, frfDetails, frfAttachmentDetails,qrfAttachmentDetails },
      match: { path },
      isDownload,
      showTitle,
      labLocationCountries
    } = this.props;
    const remediation = trfDetails && (trfDetails.statusValue === 'Awaiting Nike Response' && trfDetails.statusValue === 'FRF Submitted') ? false : true;
    const trf = trfDetails ? <TRF isDownload={isDownload} trfDetails={trfDetails} showTitle={showTitle} labLocationCountries={labLocationCountries} /> : this.noDataAvailable();
    const qrf = qrfDetails && qrfDetails.qrfId && path !== '/qrf' ? <QRF isDownload={isDownload} attachment={qrfAttachmentDetails} qrfDetails={qrfDetails} showTitle={showTitle} /> : this.noDataAvailable();
    const frf = frfDetails && frfDetails.frfId && path !== '/frf' ? <FRF isDownload={isDownload} attachment={frfAttachmentDetails} frfDetails={frfDetails} showTitle={showTitle} /> : this.noDataAvailable();
    const remediationForm = qrfDetails && qrfDetails.qrfId && path !== '/qrf' && <Remediation isDownload={isDownload} qrfDetails={qrfDetails} frfDetails={frfDetails} attachment={frfAttachmentDetails} showTitle={showTitle} attachmentEdit={true}/>;

    return (
      <div>
        {trf}
        {!remediation ? qrf : null}
        {!remediation ? frf : null}
        {remediation && remediationForm}
      </div>
    );
  }
}
TrfReview.defaultProps = {
  showTitle: true
};

TrfReview.propTypes = {
  trfData: PropTypes.object,
  match: PropTypes.object,
  isDownload: PropTypes.bool,
  showTitle: PropTypes.bool,
  labLocationCountries: PropTypes.array
};

export default withRouter(connect()(TrfReview));